import Datetime from 'react-datetime';
import {
  Button,
  IconButton,
  Typography,
  CircularProgress,
  Snackbar,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import { Alert } from '@material-ui/lab';
import React, { useState } from 'react';
import moment from 'moment';
import firebase from '../../../../config/config';
import apiCaller from '../../../../utils/apiCallerOutstanding';
import { mappedCurrentActiveRole } from '../../../../utils/roleMapping';

const InsuranceExpiry = ({
  activeRole,
  selectedTrucker,
  truckData,
  refetch,
  truckStatus,
}) => {
  const {
    vehicle_number: truckNumber,
    insurance_expiry: expiryDate,
    insurance_uploaded_by: uploadedBy,
    insurance_uploaded_at: uploadedAt,
    truck_id: truckId,
    insurance_active_flag: insuranceFlag,
  } = truckData;
  const [selectedDate, setSelectedDate] = useState(null);
  const [editExpiry, setEditExpiry] = useState(false);
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  let textColor;
  if (insuranceFlag === 0) {
    textColor = '#0A0B09';
  } else if (insuranceFlag === 1) {
    textColor = '#FF7E03';
  } else {
    textColor = '#D32F2F';
  }
  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const updateExpiry = async () => {
    setLoading(true);
    const formattedDate = moment(selectedDate).format('YYYY-MM-DD');
    const currentActiveRole = mappedCurrentActiveRole(activeRole);
    const currentUserDetails = firebase.auth().currentUser;
    const { Aa: token } = currentUserDetails;
    const body = {
      truck_id: truckId,
      role: currentActiveRole,
      vehicle_number: truckNumber,
      insurance_expiry_date: formattedDate,
    };
    const endPoint = 'pipe/truck-management/documents';
    try {
      const response = await apiCaller(
        endPoint,
        body,
        `Bearer ${token}`,
        'nh-base',
        'post'
      );
      if (response?.data?.message) {
        setSnackbarMessage(response?.data?.message);
      } else {
        setSnackbarMessage(response?.data?.Error);
      }
      setSnackbarOpen(true);
      setSelectedDate('');
      await refetch();
      setLoading(false);
    } catch (e) {
      setSnackbarMessage(e?.data?.Error);
      return e;
    }
  };

  const dayDiff = () => {
    const today = moment();
    const expiry = moment(expiryDate, 'YYYY/MM/DD');
    return today.diff(expiry, 'days');
  };
  const daysDifference = dayDiff();

  const handleEditExpiry = () => {
    setEditExpiry(true);
  };
  return (
    <div>
      {loading ? (
        <CircularProgress size={20} />
      ) : (
        <>
          {expiryDate ? (
            <div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Typography fontWeight={500}>Insurance Expiry Date</Typography>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <Typography style={{ color: textColor }}>
                    {moment(expiryDate).format('DD/MM/YYYY')}
                  </Typography>
                  <IconButton
                    aria-label="delete"
                    marginLeft="5px"
                    onClick={handleEditExpiry}
                    disabled={
                      selectedTrucker?.blacklist || truckStatus === 'pending'
                    }
                  >
                    <EditIcon />
                  </IconButton>
                </div>
              </div>
              <div>
                {editExpiry ? (
                  <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <div style={{ width: selectedDate ? '60%' : '100%' }}>
                      <Datetime
                        value={selectedDate}
                        inputProps={{
                          placeholder: 'Add Insurance Expiry Date',
                          disabled:
                            selectedTrucker?.blacklist ||
                            activeRole === 'partner-exec-manager' ||
                            truckStatus === 'pending',
                        }}
                        dateFormat="DD-MM-YYYY"
                        timeFormat={false}
                        onChange={date => {
                          if (date !== null) {
                            setSelectedDate(date);
                          }
                        }}
                      />
                    </div>
                    <div>
                      {selectedDate && (
                        <Button
                          style={{ width: '120px' }}
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            updateExpiry();
                            setEditExpiry(false);
                          }}
                        >
                          Save
                        </Button>
                      )}
                    </div>
                  </div>
                ) : (
                  <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <Typography
                      style={{
                        fontSize: '10px',
                      }}
                    >
                      {uploadedBy},{' '}
                      {moment(uploadedAt).format('MMM DD YYYY, h:mma')}
                    </Typography>
                    {insuranceFlag === 2 && (
                      <Typography
                        style={{ color: '#D32F2F', fontSize: '10px' }}
                      >
                        {daysDifference} Days Since Expiry
                      </Typography>
                    )}
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div>
              <div>
                <Typography fontWeight={500}>
                  Add Insurance Expiry Date
                </Typography>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ width: selectedDate ? '60%' : '100%' }}>
                  <Datetime
                    value={selectedDate}
                    inputProps={{
                      placeholder: 'Add Insurance Expiry Date',
                      disabled:
                        selectedTrucker?.blacklist ||
                        activeRole === 'partner-exec-manager' ||
                        truckStatus === 'pending',
                    }}
                    dateFormat="DD-MM-YYYY"
                    timeFormat={false}
                    onChange={date => {
                      if (date !== null) {
                        setSelectedDate(date);
                      }
                    }}
                  />
                </div>
                <div>
                  {selectedDate && (
                    <Button
                      style={{ width: '120px' }}
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        updateExpiry();
                      }}
                    >
                      Save
                    </Button>
                  )}
                </div>
              </div>
            </div>
          )}
        </>
      )}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={
            snackbarMessage.includes('Sucessfully updated the Expiry date')
              ? 'success'
              : 'error'
          }
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default InsuranceExpiry;
